const FileDownloader = (href, download) => {
    var a = document.createElement('a');
    a.href = href;
    a.download = download;
    a.click();
}

export { FileDownloader };